import $ from "jquery";
import { TweenMax, TimelineMax, Linear } from "gsap";
import ScrollMagic from "scrollmagic";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export function homeParallax() {
    var $home = $('.parallax');
    if ($home.length) startHomeParallax();
    var $map = $('#map');
    if ($map.length) startMapParallax();
};

function startHomeParallax() {
    var tween = TweenMax.fromTo('.parallax > div', 1,
		{translateY: 0},
		{ease: 'none', translateY: '50%'}
	);

    var controller = new ScrollMagic.Controller();
    new ScrollMagic.Scene({
		triggerElement: '.parallax',
		triggerHook: 0,
		offset: 0,
		duration: function() {return $('.parallax').height()}
	})
	.setTween(tween)
	.on("end", function (event) {
		$('#header').toggleClass('header--fixed');
	})
    .addTo(controller);

    $('.normalpage-headline-icon').each(function() {
    	var icon = this;
	    new ScrollMagic.Scene({
			triggerElement: icon,
			offset: 0,
			triggerHook: .75,
			duration: function() {return $('.parallax').height()}
		})
		.on('enter', function (event) {
			$(icon).addClass('animate');
		})
		// .on('leave', function (event) {
		// 	$(icon).removeClass('animate');
		// })
	    .addTo(controller);
    });
}

function startMapParallax() {

    var controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
		offset: 0
	}).setClassToggle("#header", "header--fixed")
    .addTo(controller);
}
